import React from 'react';
import ProgressBar from "../../widgets/ProgressBar";
import { motion } from 'framer-motion';

const skills = [
    { title: "Laravel", percentage: 95 },
    { title: "Node.js", percentage: 75 },
    { title: "Adonis.js", percentage: 90 },
    { title: "Nest.js", percentage: 85 },
    { title: "React.js", percentage: 85 },
    { title: "Vue.js", percentage: 80 },
    { title: "MySql", percentage: 90 },
    { title: "PostgreSql", percentage: 70 },
    { title: "Digital Ocean", percentage: 70 },
    { title: "Flutter", percentage: 70 },
    { title: "Figma", percentage: 50 },
];

const Skill = () => {
    return (
        <section id="skills" className="py-24 relative overflow-hidden bg-dark-900/40">
            <div className="container mx-auto px-4 lg:px-8">
                {/* Header */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-accent-cyan font-medium tracking-widest text-sm uppercase mb-3 block">
                        Mi Experiencia
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold font-display text-white mb-6">
                        Habilidades Técnicas
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-accent-blue via-accent-cyan to-accent-purple mx-auto rounded-full"></div>
                </motion.div>

                <div className="flex flex-col lg:flex-row gap-16">
                    {/* Text content */}
                    <motion.div 
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="w-full lg:w-5/12"
                    >
                        <h3 className="text-2xl font-bold text-white mb-6">Gran experiencia trabajando con estas herramientas</h3>
                        
                        <div className="space-y-4 text-slate-400 font-light leading-relaxed">
                            <p>
                                <span className="text-accent-blue font-medium">Backend:</span> Laravel (patrones de diseño, arquitectura limpia, tareas en segundo plano, APIs REST y SOAP), 
                                Node.js y Adonis.js (Sistemas en tiempo real, APIs REST, integración con OpenAI).
                            </p>
                            <p>
                                <span className="text-accent-cyan font-medium">Frontend:</span> React.js y Vue.js (Consumo de APIs, WebSockets, manejo de estado global con Redux/Vuex, arquitecturas SPA, Tailwind CSS).
                            </p>
                            <p>
                                <span className="text-accent-purple font-medium">Base de Datos & Devops:</span> MySQL y PostgreSQL. Digital Ocean para despliegue y gestión de servidores Linux. GitLab CI/CD.
                            </p>
                            <p>
                                <span className="text-white font-medium">Diseño & Mobile:</span> Flutter para Apps y Figma para prototipado UI/UX.
                            </p>
                        </div>
                    </motion.div>

                    {/* Progress Bars */}
                    <motion.div 
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="w-full lg:w-7/12"
                    >
                        <div className="glass-card p-8 rounded-2xl bg-dark-800/60">
                            {skills.map((skill, index) => (
                                <ProgressBar key={skill.title} {...skill} />
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
            
            {/* Background elements */}
            <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-accent-blue/5 rounded-full blur-[120px] -z-10 transform translate-x-1/3 translate-y-1/3"></div>
        </section>
    );
};

export default Skill;